<template>
  <div v-if="message"
       :class="['message-section message-partial', { active:activeMessage }, { ['js-has-word-highlight']:showBlacklistModal }]"
       :id="'message-' + message.id">
       <message
        :message="message"
        :campaign="autoCampaign"
        :ownerType="'AutoCampaignMessage'"
        :activeMessage="activeMessage"
        :campaignSendTime="sendTime"
        :isBudzAutoCampaign="isBudzAutoCampaign"
        isInView
        :messageModuleName="messageModuleName"
        :messagePriority="messagePriority"
        :assignedModule="stashboardMediaModuleName"
        :assignedModuleRoute="stashboardMediaModuleRoute"
        smsSend
        @update="updateMessage">
    </message>

    <div class="data-description" style="margin-top:30px;margin-bottom:20px">
      <b>select a notification message</b>

      <div>
        choose a message to send your members as a text, and we will include a secure link to the stashboard you've created above
      </div>
    </div>

    <text-notification-picker :selected="selectedNotificationTemplate"
                              :templates="notificationTemplates"
                              @update:selected="updatedSelectedNotification"
                              style="margin-bottom:10px"
                              :autoCampaignId="autoCampaignId"
                              @triggerUpdate="loadNotificationsTemplates"
    />

    <notification-images v-if="hasNotificationMmsMetaEnabled"
                               :custom-notification-images="customNotificationImages"
                               :selected-notification-image="selectedNotificationImage"
                               :suggested-notification-images="suggestedNotificationImages"
                               :isReferral="isReferral"
                               @updateSelectedNotificationImage="updateSelectedNotificationImage"
    />

    <div class="data-description">
      <b>credit summary</b>

      <div>
        characters {{ characterCount }}
        <span v-if="totalCredits > 0">, credits {{ totalCredits }}</span>
      </div>
    </div>

    <p v-if="updateError" class="api-error">{{updateError}}</p>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import { isObject } from '../../utilities'
  import {mapGetters, mapState} from 'vuex'
  import Message from '../Message/'
  import MessageModule from '../../store/modules/message'
  import TextNotificationPicker from "../TextNotificationPicker";
  import NotificationImages from '../../components/NotificationImages/notification-images.vue'
  import { notificationMessagesAPI } from "../../services/api/notificationMessagesAPI"
  import stashboardMediaModule from '../../store/modules/stashboardMedia'


  export default {
    props: {
      activeMessage: Boolean,
      autoCampaign: Object,
      autoCampaignId: String,
      autoCampaignType: Number,
      templateSubCategory: String,
      customNotificationImages: Array,
      isBudzAutoCampaign: Boolean,
      messageFromScope: Object,
      messageModuleName: String,
      messagePriority: Number,
      selectedNotificationImage: Object,
      sendTime: String,
      isReferral: Boolean,
      suggestedNotificationImages: Array
    },

    name: 'MessageEdit',

    components: {
      Message,
      NotificationImages,
      TextNotificationPicker
    },


    mixins: [AxiosMixin],

    data() {
      return {
        message: null,
        modalConfig: null,
        updateError: null,
        stashboardMediaModuleName: '',
        stashboardMediaModuleRoute: ''
      }
    },

    methods: {
      afterMessageUpdate(data, keysUpdated) {
        const message = data?.message
        if (isObject(message)) {
          this.message = message
          this.updateCommunicationItems()
          this.toggleErrorMessage()
        } else {
          this.toggleErrorMessage(keysUpdated, null, true)
        }
      },

      configureErrorKeyword(keyUpdated) {
        switch (keyUpdated) {
          case '_type':
            return 'extension'
          case '_type_options':
            return 'target wallet'
        }
      },

      initMessageEdit() {
        this.message = this.messageFromScope
        this.$store.dispatch(`${this.messageModuleName}/UPDATE_MESSAGE_ID_TYPE`, {
          autoCampaignId: this.autoCampaignId,
          autoCampaignType: this.autoCampaignType,
          messageId: this.message.id,
          messageType: 'AutoCampaignMessage'
        })
        this.stashboardMediaModuleName = `stashboard-media-AutoCampaignMessage-${this.message.id}`
        this.$store.registerModule(this.stashboardMediaModuleName, stashboardMediaModule)
        this.stashboardMediaModuleRoute = `${this.stashboardMediaModuleName}/`
        this.$store.dispatch(`${this.stashboardMediaModuleRoute}INITIALIZE_STASHBOARD_MEDIA`, {
          owner: this.autoCampaign,
          ownerType: 'AutoCampaignMessage',
          ownerId: this.message.id,
          stashboardCommunicationType: "mms",
        })
        this.updateCommunicationItems()
        this.toggleEmptyMessage()
      },

      messageUpdateError(error, keysUpdated) {
        this.toggleErrorMessage(keysUpdated, error, true)
      },

      toggleEmptyMessage() {
        let isEmpty = this.mediaCredits < 1 && this.updatedSmsContent?.length < 1
        this.$emit('updateEmptyMessage', this.message.id, isEmpty)
      },

      toggleErrorMessage(keysUpdated, error, shouldAdd) {
        if (shouldAdd) {
          let keywords = []
          keysUpdated.forEach((key) => keywords.push(this.configureErrorKeyword(key)))
          keywords = keywords.join(', ')
          this.updateError = error ? `issue updating ${keywords}. ${error}` : `issue updating ${keywords}`
        } else {
          this.updateError = null
        }
      },

      updateCommunicationItems() {
        if (this.message) {
          this.$store.commit(`SET_SELECTED_NOTIFICATION_TEMPLATE`, {
            id: this.messageModuleName,
            templateId: this.isReferral ? this.message.referral_template_id : this.message.template_id
          });
          this.$store.dispatch(`${this.messageModuleName}/UPDATE_COMMUNICATION_ITEMS`, {
            extensionType: this.message._type,
            mockUrl: this.message.mock_url,
            rewardId: this.message.reward_id,
            walletTarget: this.message._type_options
          })
          this.$store.dispatch(`${this.messageModuleName}/UPDATE_MESSAGE_STATE`, { stateKey: 'imageType', stateItem: this.message.image_type })
          this.$store.dispatch(`${this.messageModuleName}/UPDATE_SMS_CONTENT`, { smsContent: this.message.sms_content })
        }
      },

      updateMessage(dataToUpdate) {
        const params = { auto_campaign_message: dataToUpdate },
          url = `/api/v3/auto_campaign_messages/${this.message.id}?auto_campaign_id=${this.autoCampaignId}`,
          methodType = 'patch',
          onExtraParam = Object.keys(dataToUpdate)

        this.axiosMethod({methodType, url, params, onSuccess: this.afterMessageUpdate, onError: this.messageUpdateError, onExtraParam})
      },

      updatedSelectedNotification(newTemplate) {
        if(this.isReferral){
          this.updateMessage({
            referral_template_id: newTemplate.id
          });
        } else {
          this.updateMessage({
            template_id: newTemplate.id
          });
        }
        this.loadNotificationsTemplates();
      },

      updateSelectedNotificationImage(image, isReferral = false) {
        const attr = (isReferral) ? 'referral_image_id' : 'template_image_id';

        this.$emit("updateScope", {
          [attr]: (image) ? image.id : null
        });
      },

      async loadNotificationsTemplates() {
        const templates = await notificationMessagesAPI.fetchNotifications({ 'auto_campaign_id': this.autoCampaignId });
        if(templates) {
          this.$store.commit('SET_NOTIFICATION_TEMPLATES', templates)
        }
      },
    },

    beforeCreate() {
      const moduleName = this.$options.propsData.messageModuleName
      if (!this.$store.hasModule(moduleName)) { this.$store.registerModule(moduleName, MessageModule) }
    },

    created() {
      this.initMessageEdit()
    },

    beforeDestroy() {
      if (this.$store.hasModule(this.messageModuleName)) {
        this.$store.unregisterModule(this.messageModuleName)
      }
      if(this.stashboardMediaModuleName && this.$store.hasModule(this.stashboardMediaModuleName)) {
        this.$store.unregisterModule(this.stashboardMediaModuleName, stashboardMediaModule)
      }
    },

    computed: {
      ...mapState({
        hasBlacklistedWords (state) { return state[this.messageModuleName]?.hasBlacklistedWords },
        mediaCredits (state, getters) { return getters[`${this.messageModuleName}/mediaCredits`] },
        showBlacklistModal (state) { return state[this.messageModuleName]?.showBlacklistModal },
        updatedSmsContent (state) { return state[this.messageModuleName]?.updatedSmsContent },
        characterCount(state) { return state[this.messageModuleName]?.characterCount }
      }),
      totalCredits() { return this.$store.getters[`${this.messageModuleName}/totalCredits`] },
      selectedNotificationTemplate() { return this.$store.getters.selectedNotificationTemplateFor(this.messageModuleName) },
      ...mapGetters(['hasNotificationMmsMetaEnabled', 'getCampaignNotificationTemplates']),
      notificationTemplates(){
        const notifTemplates = this.getCampaignNotificationTemplates;
        if(this.templateSubCategory && this.isBudzAutoCampaign){
          return Object.keys(notifTemplates).reduce((templates, key) => {
            templates[key] = notifTemplates[key].filter(template => template.subcategory === this.templateSubCategory)
            return templates
          }, {})
        }
        return notifTemplates
      }
    },

    watch: {
      hasBlacklistedWords: function () {
        this.updateMessage({ has_blacklisted_words: this.hasBlacklistedWords })
      },

      isEmptyMessage: function () {
        this.toggleEmptyMessage()
      },
    }
  }
</script>

<style scoped>
.text-notification-picker >>> .items-container {
  position: relative;
}
</style>
